const PERSIAN_DIGIT_START = 0x06f0;
const ARABIC_DIGIT_START = 0x0660;

export const normalizeToAsciiDigits = (value) =>
  String(value ?? '').replace(/[\u06F0-\u06F9\u0660-\u0669]/g, (char) => {
    const code = char.charCodeAt(0);

    if (code >= PERSIAN_DIGIT_START && code <= PERSIAN_DIGIT_START + 9) {
      return String(code - PERSIAN_DIGIT_START);
    }

    return String(code - ARABIC_DIGIT_START);
  });

export const parseAmountValue = (value) => {
  const digits = normalizeToAsciiDigits(value).replace(/[^\d]/g, '');
  return digits ? Number(digits) : 0;
};

export const formatAmountDisplay = (value) => {
  const amount = Number(value);

  if (!Number.isFinite(amount) || amount <= 0) {
    return '';
  }

  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(amount);
};

export const formatAmountInputFromRaw = (rawValue) => {
  const digits = normalizeToAsciiDigits(rawValue).replace(/[^\d]/g, '');

  if (!digits) {
    return '';
  }

  return formatAmountDisplay(Number(digits));
};
